import emailjs from 'emailjs-com';
import React, { useState } from 'react';
import formImageTwo from '../../../images/formImageTwo.jpg'
import axios from 'axios';
// import { useForm } from "react-hook-form";
// import { Link } from 'react-router-dom';;

const ContactPageForm = () => {

  function sendEmail(e) {
    e.preventDefault();

    emailjs.sendForm('service_1hh9aod', 'template_7erbfh7', e.target, 'user_fKRJWT1HdvunM9ZM0WNnO')
      .then((result) => {
        console.log(result.text);
        console.log("email submitted successfully")
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset()
  }

  return (
    <div>
      <div className="row align-items-center emailCard px-5 pb-5 pt-5">
        <div className="col-md-7">
          {/* <img className="img-fluid" src={formImageTwo} alt="" /> */}
          <div id="contact" className="mt-5 mb-3 px-2">
            {/* <div className="text-center"> */}
            <div className="">
              <h2 className="fw-bold">CONTACT</h2>
              <h5>I am a Junior Web Developer. I work with JavaScript and React. I develop the front end of a web application using React. I am always ready to learn any kind of technology and programming language. I know HTML, CSS ,and Bootstrap also.</h5>
              <div className="d-flex flex-row bd-highlight mb-3 mt-3">
                <div className="col-md-6">
                  {/* <h5><span className="fw-bold">Address</span> 5300 Nilphamari, Bangladesh</h5> */}
                  <h5 className="fw-bold">Passion: <span className="text-secondary">Programmer</span></h5>
                  <h5 className="fw-bold">Website: <span className="text-secondary">faiyad-ahmed-sudipto.web.app</span></h5>
                  <h5 className="fw-bold">City: <span className="text-secondary">Nilphamari, Bangladesh</span></h5>
                  {/* <u>dd</u> */}
                </div>
                <div className="col-md-6">
                  <h5 className="fw-bold">Birthday: <span className="text-secondary">faiyadahmedsudipto@gmail.com</span></h5>
                  <h5 className="fw-bold">Email: <span className="text-secondary">faiyadahmedsudipto@gmail.com</span></h5>
                  <h5 className="fw-bold">Phone: <span className="text-secondary">+880 1752-082739</span></h5>
                </div>


                {/* <div className="row">
                  <div className="personal-info padd-15">
                    <p>
                      Birthday
                      :
                    <span>23 Oct, 1999</span>
                    </p>
                  </div>
                </div> */}

              </div>
            </div>
            {/* <div className="d-flex justify-content-center">

            </div> */}
          </div>
        </div>

        <div className="col-md-5 shadow p-3 px-3">
          <form onSubmit={sendEmail}>
            <div className="col-sm-15">
              <h3 htmlFor="" className="text-center">Write Your Thinking</h3>
              <input type="text" name="name" placeholder="Your Name" class="form-control" id="inputPassword" />
            </div>
            <br />
            <div className="col-sm-15">
              <input type="email" name="email" placeholder="Your Email Address" class="form-control" id="inputPassword" />
            </div>
            <br />
            <div className="col-sm-15">
              <textarea name="message" placeholder="Tell Me What Are You Thinking" class="form-control" id="inputPassword" />
            </div>

            <br />
            {/* <input type="submit" /> */}
            <input class="btn btn-primary" type="submit" value="Send"></input>
          </form>
        </div>


      </div>
    </div>
  );
};

export default ContactPageForm;